import { render, staticRenderFns } from "./StockLista.vue?vue&type=template&id=212f9104&"
import script from "./StockLista.vue?vue&type=script&lang=js&"
export * from "./StockLista.vue?vue&type=script&lang=js&"
import style0 from "./StockLista.vue?vue&type=style&index=0&id=212f9104&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports